import { Injectable } from '@angular/core';
import { AgContextMenuServiceBase } from 'src/shared/services/ag-context-menu-service-base';
import { SharedServiceHelperService } from './shared-service-helper.service';

@Injectable({
    providedIn: 'root'
})
export class AgContextMenuService extends AgContextMenuServiceBase {
    constructor(
        sshs: SharedServiceHelperService,
    ) {
        super(sshs.getSharedServicesEnabled());
    }
}
